import React, { forwardRef } from "react";
import {
  BaseLogo,
  ImageLogo,
  LogoType,
} from "../../../core/models/entities/BaseLogo";
import { Design } from "../../../core/models/entities/Design";
import { imageFallback } from "../../shared/const/imageFallback";
import { enviroment } from "../../../enviroment";

interface DesignImageProp extends React.ImgHTMLAttributes<HTMLImageElement> {
  design: Design;
  useHighRes?: boolean;
  // Flag REACT_APP_LIST_PERF_ENABLED (list rows only; same contract as
  // LogoImage): lazy = loading="lazy" + decoding="async", priority =
  // fetchpriority="high", reserve = width/height + object-fit contain. Inert
  // with the flag off = byte-identical <img>.
  lazy?: boolean;
  priority?: boolean;
  reserve?: { w: number; h: number };
}
export const DesignImage = forwardRef<HTMLImageElement, DesignImageProp>(
  (props, ref) => {
    const { design, useHighRes, lazy, priority, reserve, ...rest } = props;
    rest.src =
      (design.displayImage
        ? useHighRes
          ? design.displayImage.highResUrl
          : design.displayImage.lowResUrl
        : useHighRes
        ? design.style?.thumbnailUrl
        : design.style?.thumbnailUrlLowResolution) ?? imageFallback;
    rest.alt = design.title;
    if (enviroment.listPerfEnabled) {
      if (lazy) {
        rest.loading = "lazy";
        rest.decoding = "async";
      }
      if (priority) {
        // React 18 forwards the attribute only in its lowercase spelling.
        (rest as Record<string, unknown>)["fetchpriority"] = "high";
      }
      if (reserve) {
        rest.width = reserve.w;
        rest.height = reserve.h;
        rest.style = { ...rest.style, objectFit: "contain" };
      }
    }
    return <img ref={ref} {...rest} />;
  }
);
